function Dash() {
  return <div className="my-4 h-px w-full bg-gray-200 dark:bg-white/10" />;
}

export default Dash;
